import { render, staticRenderFns } from "./ddyTabbar.vue?vue&type=template&id=18bd5fa8&scoped=true&"
import script from "./ddyTabbar.vue?vue&type=script&lang=js&"
export * from "./ddyTabbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bd5fa8",
  null
  
)

export default component.exports